import { useEffect } from "react";
import i18n from "@/i18n/config";
import Index from "./Index";

interface LocalizedIndexProps {
  lang: string;
}

/**
 * Renders the landing page with a forced language. Used by language-specific
 * routes like /en, /no, /sv so that Googlebot lands on a page already in the
 * correct locale (matching the URL + hreflang).
 */
export default function LocalizedIndex({ lang }: LocalizedIndexProps) {
  useEffect(() => {
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
    document.documentElement.lang = lang;
  }, [lang]);

  return <Index />;
}
